<main>
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-md-9">
                <div _ngcontent-cvh-c14="" class="component-title mb-3">
                    GESTÃO DE INCENTIVOS
                </div>
                <p>Veja e gerencie os incentivos de seus favorecidos</p>
            </div>
        </div>
        <div class="separador-2"></div>
        <div class="row">
            <div class="col-md-12 text-right" *ngIf="!isMobile">
                <ul class="options-cadastro">
                    <li>
                        <div *ngIf="exibirFiltro" (click)="showFilter(filtro)" class="list-select ml-2
                            my-1">
                            <button _ngcontent-khv-c20="" class="list-select" type="button">
                                Aplicar filtro
                            </button>
                        </div>
                    </li>
                    <li>
                        <div class="list-select-search-input ml-2 my-1">
                            <input class="w-100 ng-untouched ng-pristine
                                ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="pageChangedGateway(1)" />
                        </div>
                    </li>
                    <li>
                        <div class="list-select ml-2 my-1">
                            Mostrar:
                            <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                <option _ selected="" value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="col-md-12" *ngIf="isMobile">
                <div class="list-select-search-input list-select-search-input-mobile ml-2 my-1">
                    <input class="w-100 ng-untouched ng-pristine ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="pageChangedGateway(1)" />
                </div>
                <button class="btn-search" (click)="pageChangedGateway(1)">
                    Buscar
                </button>
            </div>

        </div>

        <div class="row mt-5">
            <div class="col-12">
                <ng-container *ngFor="
                        let item of colaboradoresList
                            | paginate
                                : {
                                      itemsPerPage: showItem,
                                      currentPage: currentPage,
                                      totalItems: totalItems
                                  }
                    ">
                    <div *ngIf="isMobile">
                        <div ngbDropdown class="d-inline-block menu-option button-mobile" placement="left">
                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                <img src="assets/icons/menu.png" />
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                <section class="custom-context-menu">
                                    <div *ngIf="item.hasApp === 'Ativo'" ngbDropdownItem (click)="NavigateToResgateBeneficio(item)">
                                        <img src="assets/icons/user-purple.png" class="mr-2" />Resgate de Incentivos
                                    </div>

                                    <div *ngIf="item.hasApp === 'Ativo'" ngbDropdownItem (click)="NavigateToTransfereBeneficio(item)">
                                        <img src="assets/icons/user-purple.png" class="mr-2" />Transferência de Incentivo
                                    </div>

                                    <div ngbDropdownItem (click)="ShowModalBenefits(benefitsModal,item)">
                                        <img src="assets/icons/contrato.png" class="mr-2" />Saldos do Favorecido
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>

                    <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" *ngIf="isMobile">
                        <tbody class="list-table-row">
                            <tr>
                                <td class="td-mobile">Nome:</td>
                                <td>
                                    {{ item.name }}
                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">CPF:</td>
                                <td>
                                    {{ item.document | cpf }}
                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">{{ labelMatricula }}:</td>
                                <td>
                                    {{ item.register }}
                                </td>
                            </tr>

                            <tr>
                                <td class="td-mobile">Unidade:</td>
                                <td>
                                    <span *ngIf="item.nomeUnidade">{{
                                        item.nomeUnidade
                                    }}</span>
                                    <span *ngIf="!item.nomeUnidade">Nenhum</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>

                <div class="table-responsive">
                    <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="!isMobile">
                        <thead>
                            <tr>
                                <!-- <th></th> -->
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('name', sortOrder)
                                    ">
                                    Nome
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('document', sortOrder)
                                    ">
                                    CPF
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('register', sortOrder)
                                    ">
                                    {{ labelMatricula }}
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('costCenter', sortOrder)
                                    ">
                                    Centro de Custo
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('departament', sortOrder)
                                    ">
                                    Departamento
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('unit', sortOrder)
                                    ">
                                    Unidade
                                </th>
                                <th *ngIf="mostrarColunaAplicativo" (click)="
                                        sortOrder = !sortOrder;
                                        orderBy(
                                            'collaboratorID',
                                            sortOrder
                                        )
                                    ">
                                    Favorecido apto?
                                </th>
                                <!-- <th *ngIf="mostrarColunaAplicativo" (click)="
                                        sortOrder = !sortOrder;
                                        orderBy(
                                            'collaboratorID',
                                            sortOrder
                                        )
                                    ">
                                    Tem Cartão?
                                </th> -->
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor="
                                let item of colaboradoresList
                                    | paginate
                                        : {
                                            itemsPerPage: showItem,
                                            currentPage: currentPage,
                                            totalItems: totalItems
                                        }
                            ">
                                <td>
                                    {{ item.name }}
                                </td>
                                <td>
                                    {{ item.document | cpf }}
                                </td>
                                <td>
                                    {{ item.register }}
                                </td>
                                <td>
                                    <span *ngIf="item.costCenter">{{
                                        item.costCenter
                                    }}</span>
                                    <span *ngIf="!item.costCenter">Nenhum</span>
                                </td>
                                <td>
                                    <span *ngIf="item.departament">{{
                                        item.departament
                                    }}</span>
                                    <span *ngIf="!item.departament">Nenhum</span>
                                </td>
                                <td>
                                    <span *ngIf="item.unit">{{
                                        item.unit
                                    }}</span>
                                    <span *ngIf="!item.unit">Nenhum</span>
                                </td>
                                <td *ngIf="mostrarColunaAplicativo">
                                    <span *ngIf="item.hasApp === 'Ativo' || item.hasCard">
                                        <img class="img-status" src="./assets/icons/status-green.png" />
                                    </span>
                                    <span *ngIf="item.hasApp === 'Pendente' && !item.hasCard">
                                        <img class="img-status" src="./assets/icons/status-yellow.png" />
                                    </span>
                                </td>
                                <!-- <td *ngIf="mostrarColunaAplicativo">
                                    <span *ngIf="item.hasCard">
                                        <img class="img-status" src="./assets/icons/status-green.png" />
                                    </span>
                                    <span *ngIf="!item.hasCard">
                                        <img class="img-status" src="./assets/icons/status-yellow.png" />
                                    </span>
                                </td> -->
                                <td>
                                    <div ngbDropdown class="d-inline-block
                                        menu-option" placement="left">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                            <img src="assets/icons/menu.png" />
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                                
                                                <!--<div *ngIf="!item.hasCard" ngbDropdownItem (click)="ShowModalQRCode(modalQRCode,item)">
                                                    <img src="assets/icons/barcode.png" class="mr-2" style="width:15px" />Vincular QR Code
                                                </div>-->

                                                <div *ngIf="item.hasApp === 'Ativo'" ngbDropdownItem (click)="NavigateToResgateBeneficio(item)">
                                                    <img src="assets/icons/user-purple.png" class="mr-2" />Resgate de Incentivos
                                                </div>

                                                <div *ngIf="item.hasApp === 'Ativo'" ngbDropdownItem (click)="NavigateToTransfereBeneficio(item)">
                                                    <img src="assets/icons/transfere.png" class="mr-2" />Transferência de Incentivo
                                                </div>

                                                <div ngbDropdownItem (click)="ShowModalBenefits(benefitsModal,item)">
                                                    <img src="assets/icons/contrato.png" class="mr-2" />Saldos do Favorecido
                                                </div>

                                                <div *ngIf="item.hasCard" ngbDropdownItem (click)="ShowModalAlterarSenha(modalAlterarSenha,item)">
                                                    <img src="assets/icons/user-purple.png" class="mr-2" style="width:15px" /> Alterar Senha
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div *ngIf="colaboradoresList.length === 0" class="text-center">
                        <h6>
                            Nenhum favorecido carregado. Faça uma busca para retornar a lista de favorecidos
                        </h6>
                    </div>

                    <div class="list-pagination ml-auto" *ngIf="!isMobile">
                        <pagination-controls (pageChange)="pageChangedGateway($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="container custom-filter">
        <div class="row mx-5">
            <div class="col-12 custom-filter-title my-5">Aplicar filtro</div>
            <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input id="colaboradorId" #colaboradorId class="custom-filter-input" type="text" value="{{ filtroCodigo }}" />
                    <label class="custom-filter-label" for="colaboradorId">Código:</label>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input id="nome" #nome class="custom-filter-input" type="text" value="{{ filtroNome }}" />
                    <label class="custom-filter-label" for="nome">Nome:</label>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input id="cpf" #cpf class="custom-filter-input" type="text" value="{{ filtroCPF }}" />
                    <label class="custom-filter-label" for="cpf">CPF:</label>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <input id="matricula" #matricula class="custom-filter-input" type="text" value="{{ filtroMatricula }}" />
                    <label class="custom-filter-label" for="matricula">{{ labelMatricula }}:</label>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <label class="dropdown-label">Centro de Custo:</label>
                    <ng-multiselect-dropdown [data]="filtroCentroCustoDropDownList" [(ngModel)]="filtroCentroCustoSelectedItems" [settings]="dropDownSettings" [placeholder]="
                            'Selecionar
                        centros de custo'
                        " (onSelect)="onItemSelectFiltroCentroCusto($event)" (onSelectAll)="onSelectAllFiltroCentroCusto($event)" (onDeSelect)="onItemDeSelectFiltroCentroCusto($event)"></ng-multiselect-dropdown>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <label class="dropdown-label" for="unidade">Unidade:</label>
                    <ng-multiselect-dropdown [data]="filtroUnidadeDropDownList" [(ngModel)]="filtroUnidadeSelectedItems" [settings]="dropDownSettings" [placeholder]="
                            'Selecionar
                        unidades'
                        " (onSelect)="onItemSelectFiltroUnidade($event)" (onSelectAll)="onSelectAllFiltroUnidade($event)" (onDeSelect)="onItemDeSelectFiltroUnidade($event)"></ng-multiselect-dropdown>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-input-container">
                    <label class="dropdown-label" for="departamento">Departamento:</label>
                    <ng-multiselect-dropdown [data]="filtroDepartamentoDropDownList" [(ngModel)]="filtroDepartamentoSelectedItems" [settings]="dropDownSettings" [placeholder]="
                            'Selecionar
                        departamentos'
                        " (onSelect)="onItemSelectFiltroDepartamento($event)" (onSelectAll)="onSelectAllFiltroDepartamento($event)" (onDeSelect)="onItemDeSelectFiltroDepartamento($event)"></ng-multiselect-dropdown>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 my-4">
                <div class="custom-filter-input-container">
                    <select id="aplicativo" #aplicativo class="custom-filter-input-select label-white" [value]="filtroAplicativo">
                        <option value="" selected>Selecione...</option>
                        <option value="">Indiferente</option>
                        <option value="true">Ativo</option>
                        <option value="false">Pendente</option>
                    </select>
                    <label class="custom-filter-label" for="aplicativo">Aplicativo:</label>
                </div>
            </div>
            <div class="col-12 text-center my-5">
                <button class="custom-filter-button" type="button" (click)="
                        applyFilter(
                            colaboradorId.value,
                            nome.value,
                            cpf.value,
                            matricula.value,
                            filtroCentroCustoSelectedItems,
                            filtroUnidadeSelectedItems,
                            filtroDepartamentoSelectedItems,
                            aplicativo.value
                        );
                        modal.dismiss('Close click')
                    ">
                    APLICAR
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!--Modal do Beneficios-->
<ng-template #benefitsModal let-modal>
    <ng-container *ngIf="showBenefits">
        <div class="col-12 modal-header clean-modal-header">
            <div class="col-md-12">
                <h5 class="modal-title clean-modal-title">
                    Incentivos do favorecido
                </h5>
                <p class="clean-modal-subtitle">
                    Visualize os saldos atuais e os lançamentos futuros do favorecido.
                </p>
            </div>
        </div>
        <div class="col-12 clean-modal-content">
            <p class="clean-modal-section-title">Saldos de incentivo:</p>
            <ng-container *ngIf="
                            CollaboratorDetailsModel.currentProduct.length > 0
                        ">
                <div class="row col-md-12">
                    <div class="card col-md-4 clean-card-container" *ngFor="let currentProduct of CollaboratorDetailsModel.currentProduct
                            ">
                        <div class="card-body clean-card-content">
                            <p class="card-title mb-2">{{ currentProduct.nomeBeneficio }}</p>
                            <p class="p-list-account text-muted">{{ currentProduct.numeroCartao }}</p>
                            <p class="card-text">{{ currentProduct.valorBeneficio
                                <=0 ? "R$ 0,00" : (currentProduct.valorBeneficio | currency: "BR":true) }}</p>
                                    <span class="red" *ngIf="currentProduct.mensagemErro">
                                        ({{currentProduct.mensagemErro}})</span>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="
                            CollaboratorDetailsModel.currentProduct.length <= 0
                        ">
                <p class="p-list-account">Não existem lançamentos</p>
            </ng-container>

            <p class="clean-modal-section-title">Lançamentos futuros:</p>
            <ng-container *ngIf="
                            CollaboratorDetailsModel.futureProduct.length > 0
                        ">
                <p class="p-list-account" *ngFor="
                                let futureProduct of CollaboratorDetailsModel.futureProduct
                            ">
                    {{ futureProduct.nomeBeneficio }}: {{ futureProduct.valorBeneficio
                    <=0 ? "R$ 0,00" : (futureProduct.valorBeneficio | currency: "BR":true) }} <span class="red" *ngIf="futureProduct.mensagemErro">
                        ({{futureProduct.mensagemErro}})</span>
                        <span *ngIf="!futureProduct.mensagemErro">
                                -
                                {{
                                futureProduct.dataLiberacaoBeneficio
                                    | date: "dd/MM/yy HH:mm"
                                }}
                            </span>
                </p>
            </ng-container>

            <ng-container *ngIf="
                            CollaboratorDetailsModel.futureProduct.length <= 0
                        ">
                <p class="p-list-account">
                    Não existem lançamentos futuros
                </p>
            </ng-container>
        </div>
        <div class="col-12 clean-modal-footer">
            <button class="clean-modal-button-text button-cancel" type="button" (click)="modal.dismiss('Close click')">
                        FECHAR
                    </button>
        </div>
    </ng-container>

    <ng-container *ngIf="!showBenefits">
        <div class="col-12 clean-modal-title my-5 text-center">
            {{ messageStatus }}
        </div>
        <div class="col-12 text-center my-2">
            <button class="clean-modal-button" type="button" (click)="modal.dismiss('Close click')">
                        Ok
                    </button>
        </div>
    </ng-container>
</ng-template>

<!-- Modal QRCode
<ng-template #modalQRCode let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Cartão de incentivos
            </h5>
            <p class="clean-modal-subtitle">
                Vamos vincular o cartão ao favorecido
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-text">
            <form [formGroup]="associateCardForm" *ngIf='!messageStatus'>
                <div class="form-group col-lg-6 col-md-12 col-sm-12 float-left">
                    <div class="clean-modal-section-title">Digite o código impresso no cartão</div>
                    <input type="text" class="w-75" formControlName="code" />
                    <div class="clean-modal-section-title m-t-15p">Confirme o código</div>
                    <input type="text" class="w-75" formControlName="confirmCode" />
                </div>
                <div class="form-group col-lg-6 col-md-12 col-sm-12 float-left">
                    <div class="clean-modal-section-title" *ngIf="!usarSenhaExistente">Digite uma senha de 6 números</div>
                    <div class="clean-modal-section-title" *ngIf="usarSenhaExistente">Digite sua senha</div>
                    <input type="password" onlyNumber class="w-75" maxlength="6" formControlName="password" />
                    <ng-container *ngIf="!usarSenhaExistente">
                        <div class="clean-modal-section-title m-t-15p">Confirme a senha</div>
                        <input type="password" onlyNumber class="w-75" maxlength="6" formControlName="confirmPassword" />
                    </ng-container>
                </div>
                <button class="custom-filter-button custom-filter-button-just" (click)="vincularQrCode()">
                    Concluir associação de cartão
                </button>
            </form>
            <p class="text-center" *ngIf='messageStatus'>
                {{ messageStatus }}
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>-->

<!--Modal Alterar Senha-->
<ng-template #modalAlterarSenha let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <div>
                    <h2>Alteração de senha do cartão</h2>

                    <p class="p-just">Escolha uma senha</p>
                    <input class="w-75 d-inline-block" type="password" value="" onlyNumber maxlength="6" #inResetSenha />

                    <p class="p-just">Confirme a senha</p>
                    <input class="w-75 d-inline-block" type="password" value="" onlyNumber maxlength="6" #inResetSenhaConfirmacao />

                    <span class="legend" *ngIf="messageSenha">
                        {{ messageSenha }}
                    </span>
                </div>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button" type="button" (click)="
                        AlterarSenha(
                            inResetSenha.value,
                            inResetSenhaConfirmacao.value)">
                    Confirmar
                </button>
            </div>
            <div class="col-12 text-center mt-2 mb-5">
                <button class="custom-modal-button-text" type="button" (click)="modal.dismiss('Close click')">
                    CANCELAR
                </button>
            </div>
        </div>
    </div>
</ng-template>